module.exports = __webpack_public_path__ + "static/media/sbs.4609550d.svg";